import styled from "styled-components";
import Logo from "layouts/brand/logo.component";

export default styled(Logo)`
  .header__logo {
    width: 100%;
  }
`;
